import { render } from "./PatientRetentionChart.vue?vue&type=template&id=a81d9bae&scoped=true&ts=true"
import script from "./PatientRetentionChart.vue?vue&type=script&lang=ts"
export * from "./PatientRetentionChart.vue?vue&type=script&lang=ts"

import "./PatientRetentionChart.vue?vue&type=style&index=0&id=a81d9bae&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a81d9bae"]])

export default __exports__